import { useCallback } from 'react';
import { useMutation, gql } from '@apollo/react-hooks';
import { get, pick } from 'lodash';
import type { UpdateAssetTypeMutation, AssetType } from '#/graphql/types';
import { updateAssetType } from '#/graphql/mutations';
import fields from '../utils/mutationDataFields';
import { GET_ASSET_TYPE } from './useAssetTypeQuery';

const q = gql(updateAssetType);

const useAssetTypeUpdate = () => {
  const [mutation, result] = useMutation<UpdateAssetTypeMutation>(q);
  const updateAssetType = useCallback(
    async (itemId: string, assetType: AssetType) => {
      const response = await mutation({
        variables: {
          id: itemId,
          data: pick(assetType, fields),
        },
        refetchQueries: [{ query: GET_ASSET_TYPE, variables: { id: itemId } }],
        awaitRefetchQueries: true,
      });

      return get(response, 'data.updateAssetType', undefined);
    },
    [mutation],
  );

  return { updateAssetType, result };
};

export default useAssetTypeUpdate;
